"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SurveyorTeamContext_exports = {};
__export(SurveyorTeamContext_exports, {
  SurveyorTeamProvider: () => SurveyorTeamProvider,
  useSurveyorTeamContext: () => useSurveyorTeamContext
});
module.exports = __toCommonJS(SurveyorTeamContext_exports);
var import_topo_form = require("@cartographerio/topo-form");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
var import_react = __toESM(require("react"));
var import_calcPrimarySurveyorOptions = require("./calcPrimarySurveyorOptions.js");
var import_calcPrimaryTeamOptions = require("./calcPrimaryTeamOptions.js");
var import_calcPossibleSurveyorUsers = require("./calcPossibleSurveyorUsers.js");
const SurveyorTeamContext = (0, import_react.createContext)(null);
function useSurveyorTeamContext() {
  return (0, import_react.useContext)(SurveyorTeamContext) ?? (0, import_util.raise)((0, import_types.internalError)("Surveyor team context hasn't been initialised"));
}
function SurveyorTeamProvider(props) {
  const {
    initialSurveyor,
    initialTeamId,
    primarySurveyor,
    primaryTeamId,
    project,
    formDispatch,
    workspaceGraph,
    currentUser,
    children
  } = props;
  const users = (0, import_react.useMemo)(() => (0, import_calcPossibleSurveyorUsers.calcPossibleSurveyorUsers)({ project, workspaceGraph }), [project, workspaceGraph]);
  const teams = (0, import_react.useMemo)(
    () => workspaceGraph.findTeamsByWorkspaceId(project.workspaceId),
    [project, workspaceGraph]
  );
  const primarySurveyorOptions = (0, import_react.useMemo)(
    () => (0, import_calcPrimarySurveyorOptions.calcPrimarySurveyorOptions)({
      initialSurveyor,
      primarySurveyor,
      primaryTeamId,
      teams,
      users
    }),
    [initialSurveyor, primarySurveyor, primaryTeamId, teams, users]
  );
  const primaryTeamOptions = (0, import_react.useMemo)(
    () => (0, import_calcPrimaryTeamOptions.calcPrimaryTeamOptions)({
      users,
      teams,
      projectId: project.id,
      initialTeamId,
      primarySurveyor,
      primaryTeamId
    }),
    [initialTeamId, primarySurveyor, primaryTeamId, project.id, teams, users]
  );
  const onPrimarySurveyorChange = (0, import_react.useCallback)(
    (newUserId) => newUserId !== (primarySurveyor?.userId ?? null) ? formDispatch(
      (0, import_topo_form.changeSurveyorAction)(
        newUserId == null ? null : (
          // The current user could be a superuser, in which case they won't be in the graph:
          newUserId === currentUser.userId ? currentUser : (0, import_types.userToUserRef)(workspaceGraph.findUserById(newUserId))
        )
      )
    ) : null,
    [primarySurveyor?.userId, formDispatch, currentUser, workspaceGraph]
  );
  const onPrimaryTeamChange = (0, import_react.useCallback)(
    (newTeamId) => newTeamId !== primaryTeamId ? formDispatch((0, import_topo_form.changeTeamIdAction)(newTeamId)) : null,
    [primaryTeamId, formDispatch]
  );
  const context = (0, import_react.useMemo)(
    () => ({
      primarySurveyor,
      primaryTeamId,
      primarySurveyorOptions,
      primaryTeamOptions,
      onPrimarySurveyorChange,
      onPrimaryTeamChange
    }),
    [
      primarySurveyor,
      primaryTeamId,
      primarySurveyorOptions,
      primaryTeamOptions,
      onPrimarySurveyorChange,
      onPrimaryTeamChange
    ]
  );
  return /* @__PURE__ */ import_react.default.createElement(SurveyorTeamContext.Provider, { value: context }, children);
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  SurveyorTeamProvider,
  useSurveyorTeamContext
});
//# sourceMappingURL=SurveyorTeamContext.js.map
